export default __webpack_public_path__ + "static/media/Cover (3).18183cf0.png";